<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <h3 v-if="mData.viewMode === 'create'">THÊM MỚI BÀI VIẾT</h3>
      <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT BÀI VIẾT</h3>
      <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT BÀI VIẾT</h3>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="top"
        >
          <b-row>
            <b-col lg="8">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataForm.tieu_de"
                  @change="fn_changeTieuDe"
                  clearable
                  :disabled="mData.viewMode === 'detail'"
                ></el-input>
              </el-form-item>
              <div class="label-s">
                <el-form-item label="Nội dung" prop="noi_dung">
                  <NoiDung
                    :propDataEditor="mData.dataForm.noi_dung"
                    @newData="fn_newData"
                    :height="'580px'"
                  ></NoiDung>
                </el-form-item>
              </div>
            </b-col>
            <b-col lg="4">
              <el-form-item label="Mô tả" prop="mo_ta_ngan_gon">
                <el-input
                  type="textarea"
                  @change="fn_changeMoTa"
                  v-model="mData.dataForm.mo_ta_ngan_gon"
                  :disabled="mData.viewMode === 'detail'"
                ></el-input>
              </el-form-item>

              <el-form-item label="Tags" prop="tags" class="tags">
                <vue-tags-input
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="(newTags) => (tags = newTags)"
                  placeholder="Thêm tag"
                  :disabled="mData.viewMode == 'detail'"
                />
              </el-form-item>
              <b-row>
                <b-col md="6">
                  <el-form-item>
                    <el-checkbox
                      v-model="mData.dataForm.uu_tien"
                      :disabled="mData.viewMode == 'detail'"
                      @change="fn_changeUuTien"
                      >Bài viết ưu tiên</el-checkbox
                    >
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col cols="4">
                      <label
                        style="min-width: 55px; margin-top: 6px; color: #606266"
                        >Thứ tự</label
                      >
                    </b-col>
                    <b-col cols="8">
                      <el-input
                        placeholder="Nhập thứ tự"
                        v-model="mData.dataForm.thu_tu"
                        clearable
                        @change="fn_nhapThuTuBaiViet"
                        :disabled="
                          mData.viewMode == 'detail' ||
                          this.baiVietUuTien == false
                        "
                      >
                      </el-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item>
                    <el-checkbox
                      v-model="mData.dataForm.hien_thi"
                      :disabled="mData.viewMode == 'detail'"
                      @change="fn_changeHienThi"
                      >Hiển thị</el-checkbox
                    >
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <el-form-item label="Bài viết liên quan" prop="bai_viet_ids">
                    <el-select
                      v-model="mData.dataForm.bai_viet_ids"
                      multiple
                      filterable
                      placeholder="Bài viết liên quan"
                      :disabled="mData.viewMode === 'detail'"
                      clearable
                    >
                      <el-option
                        v-for="item in baiVietLienQuan"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <el-form-item label="Thêm ảnh" prop="">
                <div class="image-zone">
                  <div
                    class="image-btn"
                    v-show="!mData.dataForm.anh_show"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <label for="uploadImage">
                      <i class="fas fa-plus-square"></i>
                      Chọn ảnh tải lên</label
                    >
                    <input
                      type="file"
                      accept=".jpg, .png, .jpeg"
                      id="uploadImage"
                      style="display: none"
                      @change="fn_uploadImage"
                      @click="fn_onInputClick"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <div class="image-show">
                    <img
                      width="100%"
                      :src="mData.dataForm.anh_url"
                      v-show="mData.dataForm.anh_show"
                      alt="ảnh bài viết"
                    />
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      style="display: none"
                      @click="fn_remove()"
                      v-if="mData.viewMode !== 'detail'"
                    ></el-button>
                  </div>
                </div>
              </el-form-item>
              <div class="text-center" style="margin-top: 30px">
                <el-button
                  type="danger"
                  plain
                  @click="fn_cancel()"
                  v-ladda
                  v-if="
                    mData.viewMode === 'update' || mData.viewMode === 'create'
                  "
                  >hủy</el-button
                >
                <el-button
                  type="primary"
                  @click="fn_add()"
                  v-ladda
                  v-if="mData.viewMode === 'create'"
                  style="padding: 10px 40px"
                  >thêm mới</el-button
                >
                <el-button
                  type="primary"
                  @click="fn_update()"
                  v-ladda
                  v-if="mData.viewMode === 'update'"
                  style="padding: 10px 40px"
                  >cập nhật</el-button
                >
                <el-button
                  type="primary"
                  @click="fn_back()"
                  v-ladda
                  v-if="mData.viewMode === 'detail'"
                  style="padding: 10px 40px"
                  >quay lại</el-button
                >
              </div>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import VueTagsInput from "@johmun/vue-tags-input";
import DataForm from "../../../dataForm/dataFormBaiViet";
import NoiDung from "../../../component/EditorComponent.vue";
import { Circle4 } from "vue-loading-spinner";

export default {
  data() {
    return {
      oldId: "",
      baiVietLienQuanIds: [],
      baiVietLienQuan: [],
      arrayThuTu: [],
      oldThuTu: "",
      newThuTu: "",
      aLang: LanguageService.lang,
      tag: "",
      tags: [],
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        optionsThuTu: MethodService.copyObject(DataForm.thuTu),
        validForm: {
          tieu_de: [ValidService.required],
          mo_ta_ngan_gon: [ValidService.required],
          anh_id: [ValidService.required],
        },
        showThemChuyenMuc: false,
        thu_tu_current: "",
      },
      newData: "",
      baiVietUuTien: false,
      soUuTien: 0, // lấy tổng số bài viết ưu tiên để gán mặc định số thứ tự ưu tiên khi thêm mới bài viết mà có chọn ưu tiên
    };
  },
  components: {
    VueTagsInput,
    Circle4,
    NoiDung,
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_getAllBaiVietUuTien() {
      try {
        const response = await mushroom.ldp_bai_viet.listAsync({
          fields:
            "id,thu_tu,uu_tien,tieu_de,mo_ta_ngan_gon,anh_id,noi_dung,tags,bai_viet_ids,hien_thi,thoi_diem_tao,but_danh,nguoi_tao_id",
          filters: ["uu_tien=true"],
        });
        this.soUuTien = response.meta.total;
        this.baiVietLienQuanIds = response.result;
        response.result.forEach((item) => {
          this.arrayThuTu.push(item.thu_tu);
        });

        console.log("số thứ tự bài viết", this.arrayThuTu);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async fn_baiVietLienQuan() {
      try {
        const response = await mushroom.ldp_bai_viet.listAsync({
          fields: "id,uu_tien,tieu_de",
        });
        response.result.forEach((item) => {
          if (this.oldId != item.id) {
            this.baiVietLienQuan.push({
              value: item.id,
              label: item.tieu_de,
            });
          }
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.ldp_bai_viet.listAsync({
          fields:
            "id,thu_tu,uu_tien,tieu_de,mo_ta_ngan_gon,anh_id,noi_dung,tags,bai_viet_ids,hien_thi,thoi_diem_tao,but_danh,nguoi_tao_id",
          filters: ["id=" + this.$router.currentRoute.params.id],
        });
        if (!response.result[0].thu_tu) {
          response.result[0].thu_tu = null;
        }
        this.mData.dataForm = response.result[0];
        console.log("this.mData.dataForm.thu_tu", this.mData.dataForm.thu_tu);
        this.oldId = response.result[0].id;
        this.oldThuTu = response.result[0].thu_tu;
        this.baiVietUuTien = response.result[0].uu_tien; // tách riêng ra để hiển thị thứ tự theo trạng thái bài viết ưu tiên hay không
        this.loading = false;
        this.mData.dataForm.anh_show = true;
        this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
          .id(response.result[0].anh_id)
          .build();

        response.result[0].tags.forEach((item) => {
          this.tags.push({ text: item, tiClasses: ["ti-valid"] });
        });

        console.log("chi tiết bài viết", response.result[0]);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    fn_changeTieuDe() {
      this.mData.dataForm.tieu_de = this.mData.dataForm.tieu_de.trim();
    },
    fn_changeMoTa() {
      this.mData.dataForm.mo_ta_ngan_gon =
        this.mData.dataForm.mo_ta_ngan_gon.trim();
    },
    //function event thứ tự
    fn_nhapThuTuBaiViet(event) {
      if (!MethodService.isNumber(Number(event))) {
        window.toastr.warning("Thứ tự bài viết nhập số");
      } else {
        this.newThuTu = Number(event);
        this.forceUpdateUI();
        console.log("thứ tự 1111", this.newThuTu);
      }
    },
    // form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    async fn_add() {
      const tagsArray = [];
      this.tags.forEach((item) => {
        tagsArray.push(item.text);
      });

      const ldp_bai_viet_object = {
        tieu_de: this.mData.dataForm.tieu_de,
        mo_ta_ngan_gon: this.mData.dataForm.mo_ta_ngan_gon,
        noi_dung: this.newData,
        hien_thi: true,
        anh_id: this.mData.dataForm.anh_id,
        tags: tagsArray,
        bai_viet_ids: this.mData.dataForm.bai_viet_ids,
        uu_tien: this.mData.dataForm.uu_tien,
        thu_tu: this.mData.dataForm.thu_tu,
      };
      console.log("ldp_bai_viet_object", ldp_bai_viet_object);
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (ldp_bai_viet_object.tieu_de.trim() == "") {
            window.toastr.warning(
              "Tiêu đề bài viết không được nhập toàn khoảng trắng"
            );
            MethodService.stopLadda();
          } else if (!this.mData.dataForm.anh_id) {
            window.toastr.warning("Cần upload ảnh bài viết");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.uu_tien == true &&
            this.mData.dataForm.thu_tu == null
          ) {
            window.toastr.warning("Cần nhập số thứ tự");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.uu_tien == false &&
            this.mData.dataForm.thu_tu != null
          ) {
            window.toastr.warning("Cần chọn bài viết ưu tiên");
            MethodService.stopLadda();
          } else {
            try {
              //xóa thứ tự cũ
              if (this.mData.dataForm.thu_tu) {
                const responseOld = await mushroom.ldp_bai_viet.listAsync({
                  fields: "id,thu_tu",
                  filters: ["thu_tu=" + this.mData.dataForm.thu_tu], // or "your filters" ,
                });
                if (responseOld.result.length !== 0) {
                  const object_old = {
                    id: responseOld.result[0].id,
                    thu_tu: null,
                    uu_tien: false,
                  };
                  console.log("object_old", object_old);
                  console.log("object_", ldp_bai_viet_object);
                  await mushroom.ldp_bai_viet.partialUpdateAsync(object_old);
                }
              }
              //thêm mới
              await mushroom.ldp_bai_viet.createAsync(ldp_bai_viet_object);
              MethodService.stopLadda();
              this.fn_resetForm();
              window.toastr.success("Thêm mới bài viết mới thành công");
              this.$router.push({
                name: "DanhSachBaiViet",
              });
            } catch (e) {
              console.log(e);
              MethodService.showError(e.code);
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_newData(data) {
      this.newData = data;
    },
    fn_cancel() {
      this.$router.go(-1);
    },
    // thay đổi hiển thị
    fn_changeHienThi() {},

    // thay đổi chế độ bài viết ưu tiên
    fn_changeUuTien(event) {
      this.baiVietUuTien = event;
      this.mData.dataForm.thu_tu = null;
    },

    fn_changeThuTu(event) {
      this.mData.dataForm.thu_tu = event;
    },
    // cập nhật bài viết
    async fn_update() {
      const tagsArray = [];
      this.tags.forEach((item) => {
        tagsArray.push(item.text);
      });
      if (this.newThuTu == "") {
        this.newThuTu = this.oldThuTu;
      }
      if (this.mData.dataForm.uu_tien == false) {
        this.newThuTu = null;
      }
      const ldp_bai_viet_object = {
        id: this.$router.currentRoute.params.id,
        tieu_de: this.mData.dataForm.tieu_de,
        mo_ta_ngan_gon: this.mData.dataForm.mo_ta_ngan_gon,
        noi_dung: this.newData,
        hien_thi: true,
        anh_id: this.mData.dataForm.anh_id,
        tags: tagsArray,
        bai_viet_ids: this.mData.dataForm.bai_viet_ids,
        uu_tien: this.mData.dataForm.uu_tien,
        thu_tu: this.newThuTu,
      };

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (ldp_bai_viet_object.tieu_de.trim() == "") {
            window.toastr.warning(
              "Tiêu đề bài viết không được nhập toàn khoảng trắng"
            );
            MethodService.stopLadda();
          } else if (!this.mData.dataForm.anh_id) {
            window.toastr.warning("Cần upload ảnh bài viết");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.uu_tien == true &&
            this.mData.dataForm.thu_tu == null
          ) {
            window.toastr.warning("Cần nhập số thứ tự");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.uu_tien == false &&
            this.mData.dataForm.thu_tu != null
          ) {
            window.toastr.warning("Cần chọn bài viết ưu tiên");
            MethodService.stopLadda();
          } else {
            console.log("bài viết cập nhật:", ldp_bai_viet_object);
            try {
              //cập nhật thứ tự cũ
              // if (this.arrayThuTu.includes(this.mData.dataForm.thu_tu)) {
              //   const responseOld = await mushroom.ldp_bai_viet.listAsync({
              //     fields: "id,thu_tu",
              //     filters: ["thu_tu=" + this.mData.dataForm.thu_tu], // or "your filters" ,
              //   });

              //   if (
              //     responseOld.result.length !== 0 &&
              //     this.oldThuTu !== undefined
              //   ) {
              //     const object_old = {
              //       id: responseOld.result[0].id,
              //       thu_tu: this.oldThuTu,
              //       uu_tien: true,
              //     };
              //     console.log("object_old", object_old);
              //     console.log("object_", ldp_bai_viet_object);
              //     await mushroom.ldp_bai_viet.partialUpdateAsync(object_old);
              //   } else if (this.oldThuTu == undefined) {
              //     const object_old = {
              //       id: responseOld.result[0].id,
              //       thu_tu: null,
              //       uu_tien: false,
              //     };

              //     await mushroom.ldp_bai_viet.partialUpdateAsync(object_old);
              //   }
              // }
              // if (this.oldThuTu == "" && this.newThuTu == "") {
              //   const responseOld = await mushroom.ldp_bai_viet.listAsync({
              //     fields: "id,thu_tu",
              //     filters: ["thu_tu=" + this.mData.dataForm.thu_tu], // or "your filters" ,
              //   });
              //   if (responseOld.result.length != 0) {
              //     const object_old = {
              //       id: responseOld.result[0].id,
              //       thu_tu: null,
              //       uu_tien: false,
              //     };

              //     await mushroom.ldp_bai_viet.partialUpdateAsync(object_old);
              //   }
              // }

              if (this.mData.dataForm.thu_tu) {
                const responseOld = await mushroom.ldp_bai_viet.listAsync({
                  fields: "id,thu_tu",
                  filters: ["thu_tu=" + this.mData.dataForm.thu_tu], // or "your filters" ,
                });
                if (responseOld.result.length !== 0) {
                  const object_old = {
                    id: responseOld.result[0].id,
                    thu_tu: null,
                    uu_tien: false,
                  };
                  console.log("object_old", object_old);
                  console.log("object_", ldp_bai_viet_object);
                  await mushroom.ldp_bai_viet.partialUpdateAsync(object_old);
                }
              }
              // cập nhật dữ liệu mới
              const response = await mushroom.ldp_bai_viet.partialUpdateAsync(
                ldp_bai_viet_object
              );

              if (response.result == this.$router.currentRoute.params.id) {
                window.toastr.success("Cập nhật bài viết thành công");
                MethodService.stopLadda();
                this.$router.push({
                  name: "DanhSachBaiViet",
                });
              } else {
                window.toastr.warning("Dữ liệu bài viết không thay đổi");
                MethodService.stopLadda();
              }
            } catch (e) {
              console.error("Có lỗi: %o", e);
              MethodService.showError(e.code);
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // quay lại danh sách bài viết
    fn_back() {
      this.$router.go(-1);
    },

    // upload ảnh
    async fn_uploadImage() {
      try {
        let nameImage = document.getElementById("uploadImage").files[0].name;
        let typeImage = nameImage.slice(nameImage.indexOf("."));
        if (
          typeImage != ".jpg" &&
          typeImage != ".png" &&
          typeImage != ".jpeg"
        ) {
          window.toastr.warning("Vui lòng chọn đúng định dạng file ảnh");
        } else {
          let res = await mushroom.$file.uploadAsync({
            file: document.getElementById("uploadImage").files[0],
          });
          this.$forceUpdate();
          this.mData.dataForm.anh_id = res.result;
          this.mData.dataForm.anh_show = true;
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(res.result)
            .build();
        }
      } catch (e) {
        console.log(e);
        MethodService.showError(e.code);
      }
    },

    // xóa ảnh vừa upload
    fn_remove() {
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_url = "";
      this.mData.dataForm.anh_id = "";
      this.$forceUpdate();
    },
    // reset lại thẻ input khi vừa xóa ảnh
    fn_onInputClick(event) {
      event.target.value = "";
    },
  },
  async created() {
    await this.fn_getAllBaiVietUuTien();

    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "TaoBaiViet") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "BaiVietChiTiet") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatBaiViet") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
    await this.fn_baiVietLienQuan();
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 10px;
}
input {
  height: 35px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 100%;
}
::v-deep textarea {
  min-height: 100px !important;
}

.card {
  padding: 10px;
  // height: calc(100vh - 80px);
}
.image-zone {
  border: 1px dashed #409eff;
  border-radius: 5px;
  padding: 5px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-show {
  position: relative;
  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    max-height: 200px;
  }
  img,
  .el-button--danger {
    transition: 0.3s;
  }
  &:hover img {
    opacity: 0.8;
  }
  &:hover .el-button--danger {
    display: block !important;
  }
}
.image-btn {
  padding: 0px 5px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  font-size: 13px;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}
.vue-tags-input {
  max-width: unset;
}
::v-deep .tags .el-form-item__content {
  width: 100%;
}
::v-deep .ti-input {
  border-radius: 5px;
  border: 1px solid #c8ced3;
}

.el-button {
  padding: 10px;
}
.btnSubmit {
  width: 100%;
}
.btn-draf {
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 5px 15px;
  border-radius: 5px;
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.deactiveBtn {
  border: 1px solid #d3d4d6;
  background-color: #f4f4f5;
  color: rgb(109, 109, 109);
  &:hover {
    background-color: #f4f4f5;
    color: rgb(109, 109, 109);
  }
  label,
  i {
    cursor: no-drop;
  }
}
::v-deep .label-s label::after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
  font-weight: bold;
}
</style>
